import React, { useState } from "react";
import {
  Dialog, AppBar, Toolbar, IconButton, Typography, Slide, Box,
  TextField, InputAdornment, Button, Icon
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { axiosInstance as axios, endpoint } from "../../api/axios";
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from "notistack";


// Transition for dialog
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Yup validation schema
const PinSchema = Yup.object().shape({
  newPin: Yup.string()
    .matches(/^[0-9]+$/, "Hanya angka yang diperbolehkan")
    .length(6, "PIN harus 6 angka")
    .required("PIN wajib diisi"),
  confirmPin: Yup.string()
    .oneOf([Yup.ref("newPin")], "PIN tidak sama")
    .required("Konfirmasi PIN wajib diisi"),
});

const UpdatePinDialog = ({ open, data, handleClose }) => {
  const [showPin, setShowPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);

  console.log("Ini Data Props",data)

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  // Handle update button
  const handleButtonUpdatePin = async (values, { setSubmitting }) => {
    try {
      await axios.post(endpoint.forgotPin.updatePin, {
        otp: data?.otp,
        tokenOtp: data?.tokenOtp,
        new_pin: values.newPin,
        new_pin_confirmation: values.confirmPin,
      });
      enqueueSnackbar("Berhasil forgot pin!", { variant: "success" });
      navigate('/pin')
    } catch (error) {
      enqueueSnackbar("Gagal forgot pin!", { variant: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography sx={{ ml: 2, flex: 1, textAlign: "center" }} variant="h6">
            Forgot Pin
          </Typography>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Formik
          initialValues={{ newPin: "", confirmPin: "" }}
          validationSchema={PinSchema}
          onSubmit={handleButtonUpdatePin}
        >
          {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
            <Form>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type={showPin ? "text" : "password"}
                name="newPin"
                label="Pin Baru"
                placeholder="Masukkan PIN Baru"
                value={values.newPin}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.newPin && Boolean(errors.newPin)}
                helperText={touched.newPin && errors.newPin}
                sx={{
                  mb: 2,
                  bgcolor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPin(!showPin)} edge="end">
                        {showPin ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type={showConfirmPin ? "text" : "password"}
                name="confirmPin"
                label="Konfirmasi PIN Baru"
                placeholder="Masukkan Konfirmasi PIN"
                value={values.confirmPin}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.confirmPin && Boolean(errors.confirmPin)}
                helperText={touched.confirmPin && errors.confirmPin}
                sx={{
                  mb: 2,
                  bgcolor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowConfirmPin(!showConfirmPin)} edge="end">
                        {showConfirmPin ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={isSubmitting}
                sx={{
                  textTransform: "none",
                  bgcolor: "#424242",
                  borderRadius: 5,
                  ":hover": { bgcolor: "#08306b" },
                }}
              >
                {isSubmitting ? "Menyimpan..." : "Update"}
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export default UpdatePinDialog;
